import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: _ctx.computedValor,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
    onChange: _ctx.defineValorSelecionado,
    class: "ss-tamanho-completo",
    disabled: _ctx.props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_select_option, { value: 0 }, {
        default: _withCtx(() => [
          _createTextVNode("Todas")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 1 }, {
        default: _withCtx(() => [
          _createTextVNode("Vendas")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 2 }, {
        default: _withCtx(() => [
          _createTextVNode("Compras")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 3 }, {
        default: _withCtx(() => [
          _createTextVNode("Devolução de Venda")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 4 }, {
        default: _withCtx(() => [
          _createTextVNode("Devolução de Compra")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 5 }, {
        default: _withCtx(() => [
          _createTextVNode("Nota de Ajuste")
        ]),
        _: 1
      }),
      _createVNode(_component_a_select_option, { value: 6 }, {
        default: _withCtx(() => [
          _createTextVNode("Nota Complementar")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "onChange", "disabled"]))
}